import { useNavigate, useParams } from "react-router-dom";

export default function useAuthNavigate() {
  const navigate = useNavigate();
  const { orgSlug } = useParams();
  return function (path: string, state?: any) {
    navigate(`/${orgSlug}${path}`, state);
  };
}
